<template>
  <div class="fluid" id="assetUsageList">
    <div>
      <div class="asset-usage-list-div">
        <v-card class="px-3 py-2" style="overflow: hidden">
          <v-row>
            <v-col
              cols="12"
              class="d-flex"
              style="
                position: relative;
                padding: 0 20px;
                text-align: center;
                margin-top: 20px;
              "
            >
              <h6 class="indigo--text" style="font-weight: bold; margin: auto">
                ASSET MANAGEMENT SYSTEM
              </h6>
            </v-col>
            <v-col cols="12">
              <div class="asset-list-toolbar">
                <v-toolbar
                  class="asset-usage-list-toolbar-1"
                  flat
                  style="height: 60px; border-radius: 10px 10px 0 0"
                >
                  <v-toolbar-title
                    >List Pemakaian Aset
                    <v-tooltip bottom color="grey">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          x-small
                          text
                          icon
                          color="grey darken-2"
                          @click="initDataTable"
                        >
                          <v-icon small>mdi-refresh</v-icon>
                        </v-btn>
                      </template>
                      <span>refresh page</span>
                    </v-tooltip></v-toolbar-title
                  >
                  <v-divider class="mx-6" inset vertical></v-divider>
                  <v-spacer></v-spacer>

                  <!-- <div style="width:200px;margin-right:10px;margin-left:90px;">
                    <v-text-field
                      class="ml-1 mr-2"
                      dense
                      label="Tanggal"
                      type="date"
                      name="startdate"
                      style="height:30px;"
                      step="1"
                    />
                  </div> -->
                  <div style="width: 200px; margin-right: 10px">
                    <v-select
                      :items="dropDownCompany"
                      v-model="paramAPI.company_id"
                      style="
                        height: 30px;
                        position: relative;
                        top: 3px;
                        margin-left: 10px;
                        font-size: 16px;
                      "
                      label="Perusahaan"
                      item-text="name"
                      item-value="id"
                      return-id
                      clearable
                      dense
                      @change="companyWatcher"
                    ></v-select>
                  </div>
                  <div style="width: 200px; margin-right: 10px">
                    <v-select
                      :items="dropDownStatus"
                      v-model="paramAPI.status"
                      style="
                        height: 30px;
                        position: relative;
                        top: 3px;
                        margin-left: 10px;
                        font-size: 16px;
                      "
                      label="status"
                      item-text="name"
                      item-value="id"
                      return-id
                      clearable
                      dense
                    ></v-select>
                  </div>
                </v-toolbar>
                <v-toolbar
                  class="asset-usage-list-toolbar-1"
                  flat
                  style="height: 60px; border-radius: 10px 10px 0 0"
                >
                  <!-- <div style="margin-right:10px;">
                    <div style="width: 130px">
                      <v-select
                        label="Action"
                        style="
                      position: relative;
                      top: 15px;
                      margin-left: 5px;
                      font-size: 12px;
                    "
                        :items="[
                          { id: 0, name: '' },
                          { id: 1, name: 'Edit' },
                          { id: 4, name: 'Delete' },
                          { id: 5, name: 'Hide' }
                        ]"
                        item-text="name"
                        item-value="id"
                        outlined
                        return-id
                        dense
                      ></v-select>
                    </div>
                  </div> -->

                  <router-link to="/asset-management/form-pemakaian">
                    <v-btn
                      outlined
                      elevation="1"
                      color="indigo"
                      class="indigo--text font-weight-bold"
                      style="font-size: 12px; margin-right: 20px"
                    >
                      Formulir Pemakaian Aset
                    </v-btn>
                  </router-link>
                  <v-divider
                    class="mx-6"
                    inset
                    vertical
                    style="border: 1px solid transparent"
                  ></v-divider>
                  <div class="asset-usage-list-toolbar-div">
                    <v-text-field
                      v-model="paramAPI.keyword"
                      label="search here"
                      type="search"
                      append-icon="mdi-magnify"
                      outlined
                      dense
                      @keyup.enter="searchEnter"
                      style="position: relative; top: 15px; width: 10px"
                    ></v-text-field>
                  </div>
                </v-toolbar>
              </div>

              <div class="asset-list-toolbar-2">
                <v-expansion-panels flat accordion>
                  <v-expansion-panel v-for="(item, i) in 1" :key="i" flat>
                    <v-expansion-panel-header
                      class="d-flex align-items-start"
                      style="padding: 0 0 0 15px"
                    >
                      <p style="color: rgba(0, 0, 0, 0.4)">
                        Tampilkan Filter & Pencarian
                      </p>
                      <template v-slot:actions>
                        <v-icon color="primary"> $expand </v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content id="expansionPanelContent">
                      <div class="asset-list-toolbar-1">
                        <v-toolbar
                          class="asset-usage-list-toolbar-1"
                          flat
                          style="height: 60px; border-radius: 10px 10px 0 0"
                        >
                          <div>
                            <v-select
                              :items="dropDownCompany"
                              v-model="paramAPI.company_id"
                              style="
                                height: 30px;
                                position: relative;
                                top: 3px;
                                font-size: 16px;
                              "
                              label="dari"
                              item-text="name"
                              item-value="id"
                              return-id
                              dense
                              @change="companyWatcher"
                            ></v-select>
                          </div>
                        </v-toolbar>
                        <v-toolbar
                          class="asset-usage-list-toolbar-1"
                          flat
                          style="height: 60px; border-radius: 10px 10px 0 0"
                        >
                          <div>
                            <v-select
                              :items="dropDownStatus"
                              v-model="paramAPI.status"
                              style="
                                height: 30px;
                                position: relative;
                                top: 3px;
                                font-size: 16px;
                              "
                              label="status"
                              item-text="name"
                              item-value="id"
                              return-id
                              dense
                            ></v-select>
                          </div>
                        </v-toolbar>
                      </div>
                      <v-toolbar
                        class="asset-list-toolbar-2"
                        flat
                        style="border-radius: 10px 10px 0 0"
                      >
                        <v-text-field
                          v-model="paramAPI.keyword"
                          label="Cari disini"
                          type="search"
                          outlined
                          dense
                          @keyup.enter="searchEnter"
                          style="position: relative; top: 15px; width: 10px"
                        ></v-text-field>
                      </v-toolbar>
                      <v-toolbar
                        class="asset-list-toolbar-2"
                        flat
                        style="
                          border-radius: 10px 10px 0 0;
                          border-bottom: 1px solid #e0e0e0;
                          width: 100%;
                        "
                      >
                        <router-link
                          to="/asset-management/form-pemindahan"
                          style="width: 100%"
                        >
                          <v-btn
                            outlined
                            elevation="1"
                            color="indigo"
                            class="indigo--text font-weight-bold"
                            style="font-size: 12px; width: 100%"
                          >
                            Buka Formulir Pemindahan Aset
                          </v-btn>
                        </router-link>
                      </v-toolbar>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-col>

            <v-col cols="12" style="overflow: auto">
              <v-data-table
                mobile-breakpoint="0"
                fixed-header
                height="50vh"
                :headers="headers"
                style="cursor: pointer"
                :items="result"
                :loading="loading"
                @click:row="rowClick"
                item-key="id"
                :options.sync="options"
                :footer-props="{
                  showFirstLastPage: true,
                  showCurrentPage: true,
                  itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
                }"
                :server-items-length="totalData"
                :page="paramAPI.page"
                @update:page="updatePage"
                :items-per-page="paramAPI.itemsPerPage"
                @update:items-per-page="updateItemPerPage"
              >
                <template v-slot:[`item.created_at`]="{ item }">
                  <div style="padding: 0; display: flex; font-size: 12px; flex-direction: row">
                    {{ item.created_at }}
                  </div>
                </template>
                <template v-slot:[`item.usage_location`]="{ item }">
                  <div style="padding: 0; display: flex; font-size: 12px; flex-direction: row">
                    {{ item.usage_location }}
                  </div>
                </template>
                <template v-slot:[`item.qty`]="{ item }">
                  <div style="padding: 0; display: flex; font-size: 12px; flex-direction: row">
                    {{ item.qty }}
                  </div>
                </template>
                <template v-slot:[`item.doc_no`]="{ item }">
                  <div style="padding: 0; display: flex; font-size: 12px; flex-direction: row">
                    {{ item.doc_no }}
                  </div>
                </template>
                <template v-slot:[`item.company_name`]="{ item }">
                  <div style="padding: 0; display: flex; font-size: 12px; flex-direction: row">
                    {{ item.company_name }}
                  </div>
                </template>
                <template v-slot:[`item.asset`]="{ item }">
                  <div style="padding: 0; display: flex; font-size: 12px; flex-direction: row">
                    {{ `(${item.asset_code}) ${item.asset_name}` }}
                  </div>
                </template>
                <template v-slot:[`item.lot_no`]="{ item }">
                  <div style="padding: 0; display: flex; font-size: 12px; flex-direction: row">
                    {{ item.lot_no }}
                  </div>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <div
                    :style="`padding: 0; display: flex; font-size: 12px; flex-direction: row; color:${color(
                      item.status
                    )};`"
                  >
                    {{ usageStatus(item.status) }}
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
    <usage-detail
      :moveId="detail"
      v-if="detail !== null"
      @loadPage="initDataTable"
    />
    <div style="position: fixed; bottom: 10px; right: 0">
      <Scanner />
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import buildType from '../../../services/buildType.js'
export default {
  components: {
    UsageDetail: () => import('./Detail'),
    Scanner: () => import('../../home/components/Scanner.vue')
  },
  data: () => ({
    asset: buildType.apiURL('asset'),
    eSanqua: buildType.apiURL('esanqua'),
    isAdmin: true,
    totalData: 0,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      status: null,
      sortBy: 'doc_no',
      sortType: 'desc',
      company_id: null
    },
    options: {},
    headers: [
      {
        text: 'No. Dokumen',
        value: 'doc_no',
        align: 'left',
        sortable: true
      },
      {
        text: 'Perusahaan',
        value: 'company_name',
        align: 'left',
        sortable: false
      },
      {
        text: 'Asset',
        value: 'asset',
        align: 'left',
        sortable: false
      },
      {
        text: 'No. Lot',
        value: 'lot_no',
        align: 'left',
        sortable: false
      },
      {
        text: 'Qty',
        value: 'qty_used',
        align: 'left',
        sortable: false
      },
      {
        text: 'Lokasi',
        value: 'usage_location',
        align: 'left',
        sortable: false
      },
      {
        text: 'Tgl. Digunakan',
        value: 'planned_date',
        align: 'left',
        sortable: true
      },
      {
        text: 'Status',
        value: 'status',
        align: 'left',
        sortable: false
      },
      {
        text: 'Tgl. Dibuat',
        value: 'created_at',
        align: 'left',
        sortable: true
      }
    ],
    result: [],
    detail: null,
    loading: false,
    dropDownCompany: [],
    dropDownStatus: [],
    isDisableCompanyDropdown: false,
    userLevel: null
  }),
  created() {
    this.paramAPI.company_id = Number(
      this.getUserProfile.employee.company.plant_id
    )
    this.dropdownCompany()
    this.dropdownStatus()
    this.initDataTable()
  },
  computed: {
    ...mapGetters(['getIsLoading', 'getUserProfile'])
  },
  watch: {
    'paramAPI.status'() {
      this.initDataTable()
    },
    options: {
      handler(newVal, oldVal) {
        console.log('options handle', newVal, oldVal)
        if (
          newVal.page !== oldVal.page
          //  ||
          // newVal.itemsPerPage !== oldVal.itemsPerPage
        ) {
          return
        }

        if (
          this.options.sortBy.length === 1 &&
          this.options.sortDesc.length === 1
        ) {
          this.paramAPI.sortType = this.options.sortDesc[0] ? 'desc' : 'asc'
          this.paramAPI.sortBy =
            this.options.sortBy[0] == 'doc_no'
              ? 'id'
              : this.options.sortBy[0]
          // this.paramAPI.sortBy = 'id'
        } else {
          this.paramAPI.sortType = 'asc'
          this.paramAPI.sortBy = 'id'
        }
        // this.resetSomeParam()
        this.initDataTable()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([]),
    ...mapMutations(['setIsLoading']),

    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    async updatePage(p) {
      console.log('update page>>>', p)
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      this.initDataTable()
    },
    async updateItemPerPage(p) {
      console.log('update updateItemPerPage>>>', p)
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      this.initDataTable()
    },
    companyWatcher(val) {
      if (val != null) {
        this.initDataTable()
      }
    },
    async dropdownCompany() {
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          if (res.data.status_code == '00') {
            this.dropDownCompany = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    dropdownStatus() {
      this.dropDownStatus = [
        { id: null, name: 'default' },
        { id: -2, name: 'Canceled' },
        { id: -1, name: 'Rejected' },
        { id: 0, name: 'Draft' },
        { id: 1, name: 'Waiting' },
        { id: 2, name: 'Approved' }
      ]
    },
    searchEnter() {
      this.initDataTable()
    },
    initDataTable() {
      let apiLink = `${this.asset}usage/list?keyword=${this.paramAPI.keyword}&order_by=${this.paramAPI.sortBy}&order_type=${this.paramAPI.sortType}&offset=${this.paramAPI.offset}&limit=${this.paramAPI.limit}`

      if (this.paramAPI.company_id) {
        apiLink = apiLink + `&company_id=${this.paramAPI.company_id}`
      }
      if (this.paramAPI.status) {
        apiLink = apiLink + `&status=${this.paramAPI.status}`
      }

      axios
        .get(apiLink)
        .then((res) => {
          if (res.data.status_code == '00') {
            this.result = res.data.data
            this.totalData = res.data.total_record
          } else {
            this.result = []
          }
        })
        .catch((err) => {
          this.result = []
          console.log(err)
        })
    },
    rowClick(pValue) {
      this.$router.push(`/asset-management/detail-pemakaian/${pValue.id}`)
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleDateString()
        return local
        // const year = local.slice(0, local.indexOf('-'))
        // const month = local.slice(
        //   local.indexOf('-') + 1,
        //   local.lastIndexOf('-')
        // )
        // const day = local.slice(local.lastIndexOf('-') + 1)

        // return (day + '-' + month + '-' + year).replace(/-/g, '/')
      }
    },
    usageStatus(v) {
      switch (v) {
        case -2:
          return 'Canceled'
        case -1:
          return 'Rejected'
        case 0:
          return 'Draft'
        case 1:
          return 'Waiting'
        case 2:
          return 'Approved'

        default:
          return 'null'
      }
    },
    color(v) {
      switch (v) {
        case -2:
          return 'red'
        case -1:
          return 'red'
        case 0:
          return 'black'
        case 1:
          return 'orange'

        case 2:
          return 'green'

        default:
          return 'black'
      }
    }
  }
}
</script>

<style lang="scss">
#assetUsageList {
  .asset-usage-list-div {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .asset-usage-list-toolbar-1 {
      display: flex;
      flex-direction: column;
      .asset-usage-list-toolbar-div {
        width: 30%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .asset-list-toolbar-1 {
      display: none;
    }
    .asset-list-toolbar-2 {
      display: none;
    }
  }
}

.arch-add-new-btn {
  padding: 1px 4px;
  box-shadow: 1px 1px 1px rgb(134, 132, 132);
  border: 1px solid #cacad4;
  cursor: pointer;
  margin-top: 5px;
  text-align: left;
  font-size: 12px;
  &:hover {
    box-shadow: 1px 2px 7px rgb(134, 132, 132);
    color: blue;
    text-decoration: underline;
  }
}

.arch-expDate {
  cursor: pointer;
  height: 40px;
  .arch-exp-date {
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;

    .arch-exp-date-notif {
      overflow: hidden;
      width: 120px;
      position: absolute;
      left: 0;
      .exp-date-notif-div {
        display: flex;

        .exp-date-notif-chip1 {
          width: 95px;
          font-size: 10px;
        }
        .exp-date-notif-chip2 {
          font-size: 10px;
          .date-notif-chip2-p {
            width: 70px;
            margin: 0;
            margin: auto;
            text-align: center;
            // padding: 0 7px;
          }
        }
      }
    }
  }

  &:hover .arch-exp-date-notif {
    width: 0;
    transition: 0.5s;
  }
}

#expansionPanelContent > * {
  padding: 0px;
}
@media (max-width: 768px) {
  #assetUsageList {
    .asset-usage-list-div {
      .asset-usage-list-toolbar-1 {
        .asset-usage-list-toolbar-div {
          display: none;
        }
      }
      .asset-list-toolbar {
        display: none;
      }
      .asset-list-toolbar-1 {
        display: block;
      }
      .asset-list-toolbar-2 {
        display: block;
      }
    }
  }
}
</style>
